import { useState, type FormEvent } from "react";
import { api } from "./api";

export function SignIn({ onSignedIn }: { onSignedIn: () => void }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.login(password);
      onSignedIn();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Sign-in failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="mx-auto flex min-h-dvh max-w-lg flex-col justify-center px-5 py-10">
      <div className="animate-fade-up">
        <p className="text-xs font-medium tracking-[0.18em] text-[color:var(--color-sea)] uppercase">
          Staging
        </p>
        <h1 className="mt-2 font-[family-name:var(--font-display)] text-4xl leading-tight text-[color:var(--color-ink)] sm:text-5xl">
          Newark Law Offices
        </h1>
        <p className="mt-3 max-w-md text-[color:var(--color-ink-soft)]">
          Case desks queue for intake review. Sign in with the firm site password to open ranked
          filings and pipeline workups.
        </p>
      </div>

      <form
        onSubmit={onSubmit}
        className="animate-fade-up-delay mt-8 space-y-4 border-t border-[color:var(--color-brass)]/35 pt-8"
      >
        <label className="block text-sm font-medium text-[color:var(--color-ink)]">
          Site password
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-1.5 w-full rounded-md border border-[color:var(--color-ink)]/15 bg-white/70 px-3 py-2.5 shadow-sm outline-none ring-[color:var(--color-sea)]/30 focus:ring-2"
            required
          />
        </label>
        {error ? (
          <p className="text-sm text-[color:var(--color-danger)]" role="alert">
            {error}
          </p>
        ) : null}
        <button
          type="submit"
          disabled={busy}
          className="w-full rounded-md bg-[color:var(--color-sea)] px-4 py-2.5 text-sm font-medium text-white transition hover:bg-[color:var(--color-ink)] disabled:opacity-60 sm:w-auto"
        >
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
